import React from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export interface ColorPickerIconProps {
  foregroundColor?: string | null;
  backgroundColor?: string | null;
  /**
   * Icon string identifier used to display icon in the button.
   *
   * @default 'font'
   */
  icon?: BenchlingIconName;
  /**
   * Alt text for the icon.
   */
  iconAltText?: string;
}

function ColorPickerIcon(props: ColorPickerIconProps): JSX.Element {
  return (
    <BenchlingIcon
      icon={props.icon ?? 'font'}
      altText={props.iconAltText}
      style={{
        color: props.foregroundColor ?? undefined,
        backgroundColor: props.backgroundColor ?? undefined,
      }}
    />
  );
}

export default ColorPickerIcon;
